export const VIBRATE = 'vibrate'
export const TOGGLE_MUSIC = 'TOGGLE_MUSIC'
export const TOGGLE_SOUND = 'TOGGLE_SOUND'
export const TOGGLE_VIBRATION = 'TOGGLE_VIBRATION'
export const SOUND_EVENT_PLAY = 'PLAY'
export const SOUND_EVENT_RELEASE = 'RELEASE'